/** Looks up global `s` by name, returning `undefined` where the environment has no such global. */
export const Detect = <T>(s: string): T | undefined =>
  (globalThis as Record<string, unknown>)[s] as T | undefined
